"use client";

import * as React from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import {
  COMMAND_PRIORITY_CRITICAL,
  $getRoot,
  $getSelection,
  PASTE_COMMAND,
} from "lexical";

import { LEXICAL_NAMESPACE } from "../constants";

const LEXICAL_CLIPBOARD_MIME = "application/x-lexical-editor";

function clipboardLooksLikeOurLexical(dt: DataTransfer): boolean {
  const raw = dt.getData(LEXICAL_CLIPBOARD_MIME);
  if (raw) {
    try {
      const p = JSON.parse(raw) as { namespace?: string };
      return p.namespace === LEXICAL_NAMESPACE;
    } catch {
      return false;
    }
  }
  const types = dt.types;
  if (types == null) return false;
  return Array.from(types).includes(LEXICAL_CLIPBOARD_MIME);
}

/**
 * `PASTE_COMMAND` 默认在 `selection === null` 时直接 `return false`，不会插入；
 * 关闭手柄菜单 / 失焦后常见选区为空但有本编辑器 Lexical 剪贴板数据。
 * 在**同步**的命令上下文中调用 `root.selectEnd()`（禁止再包 `editor.update`），让后续默认粘贴能拿到选区。
 */
export function LexicalClipboardPasteFocusPlugin() {
  const [editor] = useLexicalComposerContext();

  React.useEffect(() => {
    return editor.registerCommand(
      PASTE_COMMAND,
      (event) => {
        if (!editor.isEditable()) return false;
        if (!(event instanceof ClipboardEvent) || event.clipboardData == null) return false;
        if (!clipboardLooksLikeOurLexical(event.clipboardData)) return false;
        if ($getSelection() !== null) return false;
        $getRoot().selectEnd();
        return false;
      },
      COMMAND_PRIORITY_CRITICAL,
    );
  }, [editor]);

  return null;
}
